// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.market-country-controls__availability > .radio-option {
    display: flex !important;
    gap: 0.5rem;
    align-items: flex-start;
    justify-content: flex-start;
    width: auto;
    margin: 0.5rem 0;
}

.market-country-controls__availability > .radio-option input {
    flex: 0 0 auto;
    width: auto;
    margin-top: 0.2rem;
}

.market-country-controls__availability .market-country-controls__countries {
    margin-top: 1rem;
}

.market-country-controls__inherited {
    margin-top: -0.5rem;
}

.shipping-summary-tools {
    margin-top: 1.25rem;
    padding-top: 0.75rem;
    border-top: 1px solid #e0e0e0;
}

.product-destination-overrides {
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    background: #fafafa;
}

.product-destination-overrides > summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.7rem 0.85rem;
    color: #555;
    cursor: pointer;
    list-style: none;
}

.product-destination-overrides > summary::-webkit-details-marker {
    display: none;
}

.product-destination-overrides__summary {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 0.15rem;
}

.product-destination-overrides__summary strong {
    color: #333;
    font-size: 0.9rem;
}

.product-destination-overrides__summary > span {
    overflow: hidden;
    font-size: 0.8rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.product-destination-overrides__edit::after {
    content: 'Edit';
    color: #555;
    font-size: 0.8rem;
    font-weight: 600;
}

.product-destination-overrides[open]
    .product-destination-overrides__edit::after {
    content: 'Close';
}

.product-destination-overrides__body {
    padding: 0.85rem;
    border-top: 1px solid #e0e0e0;
    background: #fff;
}

.product-destination-overrides__body > .help {
    margin-top: 0;
}

[data-theme="dark"] .shipping-summary-tools,
[data-theme="dark"] .product-destination-overrides__body {
    border-color: #3a463e;
}

[data-theme="dark"] .product-destination-overrides {
    border-color: #3a463e;
    background: #1c2620;
}

[data-theme="dark"] .product-destination-overrides > summary,
[data-theme="dark"] .product-destination-overrides__summary strong,
[data-theme="dark"] .product-destination-overrides__edit::after {
    color: #d9e4dd;
}

[data-theme="dark"] .product-destination-overrides__body {
    background: #152019;
}

@media (max-width: 600px) {
    .product-destination-overrides > summary {
        align-items: flex-start;
    }

    .product-destination-overrides__summary > span {
        white-space: normal;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/MarketCountryControls.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".market-country-controls__availability > .radio-option {\n    display: flex !important;\n    gap: 0.5rem;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: auto;\n    margin: 0.5rem 0;\n}\n\n.market-country-controls__availability > .radio-option input {\n    flex: 0 0 auto;\n    width: auto;\n    margin-top: 0.2rem;\n}\n\n.market-country-controls__availability .market-country-controls__countries {\n    margin-top: 1rem;\n}\n\n.market-country-controls__inherited {\n    margin-top: -0.5rem;\n}\n\n.shipping-summary-tools {\n    margin-top: 1.25rem;\n    padding-top: 0.75rem;\n    border-top: 1px solid #e0e0e0;\n}\n\n.product-destination-overrides {\n    border: 1px solid #d8d8d8;\n    border-radius: 6px;\n    background: #fafafa;\n}\n\n.product-destination-overrides > summary {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.7rem 0.85rem;\n    color: #555;\n    cursor: pointer;\n    list-style: none;\n}\n\n.product-destination-overrides > summary::-webkit-details-marker {\n    display: none;\n}\n\n.product-destination-overrides__summary {\n    display: flex;\n    min-width: 0;\n    flex-direction: column;\n    gap: 0.15rem;\n}\n\n.product-destination-overrides__summary strong {\n    color: #333;\n    font-size: 0.9rem;\n}\n\n.product-destination-overrides__summary > span {\n    overflow: hidden;\n    font-size: 0.8rem;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.product-destination-overrides__edit::after {\n    content: 'Edit';\n    color: #555;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.product-destination-overrides[open]\n    .product-destination-overrides__edit::after {\n    content: 'Close';\n}\n\n.product-destination-overrides__body {\n    padding: 0.85rem;\n    border-top: 1px solid #e0e0e0;\n    background: #fff;\n}\n\n.product-destination-overrides__body > .help {\n    margin-top: 0;\n}\n\n[data-theme=\"dark\"] .shipping-summary-tools,\n[data-theme=\"dark\"] .product-destination-overrides__body {\n    border-color: #3a463e;\n}\n\n[data-theme=\"dark\"] .product-destination-overrides {\n    border-color: #3a463e;\n    background: #1c2620;\n}\n\n[data-theme=\"dark\"] .product-destination-overrides > summary,\n[data-theme=\"dark\"] .product-destination-overrides__summary strong,\n[data-theme=\"dark\"] .product-destination-overrides__edit::after {\n    color: #d9e4dd;\n}\n\n[data-theme=\"dark\"] .product-destination-overrides__body {\n    background: #152019;\n}\n\n@media (max-width: 600px) {\n    .product-destination-overrides > summary {\n        align-items: flex-start;\n    }\n\n    .product-destination-overrides__summary > span {\n        white-space: normal;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
